<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-3">Felhasználási feltételek</h1>
      <div class="bordered-container mt-4">
        <b-row cols="1" class="text-left">
          <b-col>
            <p align="center">
              <strong>FELHASZNÁLÁSI FELTÉTELEK</strong>
              <strong></strong>
            </p>
            <p align="center">
              <strong>(Közzététel dátuma: 2021.01.05)</strong>
            </p>
            <p>
              <strong>1. </strong>
              A jelen felhasználási feltételek (a továbbiakban „Felhasználási Feltételek") a
              <a href="http://www.vali.hu">www.vali.hu</a> honlap (a továbbiakban „Honlap" melybe annak aloldalait is
              beleértjük) valamennyi a Honlapra belépő, vagy azt egyéb módon használó személyre (a továbbiakban:
              felhasználó) vonatkoznak.
              <br />
              A honlap használatával a Felhasználó a jelen felhasználási feltételekben foglaltakat magára nézve
              kötelezőnek elfogadja.
            </p>
            <p>
              Felhasználó vállalja, hogy a Honlap használata során jelen felhasználási feltételek mellett, a
              használattal összefüggésben irányadó jogszabályi rendelkezéseket betartja.
            </p>
            <p>
              <strong>2. </strong>
              <strong>A honlap rendeltetése:</strong>
            </p>
            <p>
              A Vállalkozói Információs Portál (VALI.HU) célja, hogy segítse a magyar vállalkozásokat különféle
              információk, és lehetőségek könnyebben elérhetővé tételével – A honlap segítségével a felhasználó egy
              adatbázisból le tudja kérni cége fontosabb adatait és a cége számára rendelkezésre álló pénzügyi és
              képzési lehetőségeket, szakértői adatbázisokat, illetve egyéb releváns információkat: A vállalkozókat,
              vállalkozásokat érintő legfrissebb híreket, különféle éppen aktuális tájékoztatásokat. A honlap legtöbb
              funkciója regisztráció nélkül is elérhető, de a cég-specifikus funkciókhoz, információkhoz regisztráció
              szükséges.
            </p>
            <p>
              Felhasználó a Honlap egyes szolgáltatásait csak regisztrációt követően a jelen meghatározott adatai
              megadásával jogosult igénybe venni. Az adatkezelésre a jelen Felhasználási feltételek 10. pontjában
              foglaltak az irányadók.
            </p>
            <p>
              <strong>3. </strong>
              <strong>Regisztráció</strong>
            </p>
            <p>
              <strong></strong>
            </p>
            <p>
              <strong>A regisztráció menete:</strong>
            </p>
            <p>
              A regisztráció első lépéseként egy cég kiválasztása szükséges a főoldalon található cégkereső funkció
              segítségével. A cégkeresést követően megtekinthetők a cég fontosabb adatai, innen való továbblépéssel
              pedig a cég számára rendelkezésre álló lehetőségek számszerűsítve. A regisztráció gomb erről az oldalról
              elérhető, a regisztrációs formon egy jelszót, illetve az alábbi négy adatot kell megadni:
            </p>
            <ul>
              <li>
                Teljes név,
              </li>
              <li>
                Felhasználónév,
              </li>
              <li>
                Telefonszám,
              </li>
              <li>
                E-mail cím
              </li>
            </ul>
            <p>
              A regisztráció történhet közösségi médiás (Facebook, LinkedIn, Google) fiókkal összekötve is, ilyenkor a
              „Teljes név”, és az „E-mail cím” mezőket a kapcsolt közösségi-média fiókból automatikusan átvesszük.
            </p>
            <p>
              Az adatok megadását követően el kell fogadni felhasználási feltételeinket, ezt követően válik aktívvá a
              Regisztráció gomb.
            </p>
            <p>
              A regisztrációt követően a rendszer generál egy automatikus üzenetet a felhasználó által megadott, vagy a
              közösségi médiás fiókból átvett e-mail címre. Ez az üzenet tartalmazza a linket mellyel megerősíthető a
              regisztráció. A regisztráció megerősítése gomb automatikusan visszavezet az oldalra, ahol a korábban
              kiválasztott cégben kell kiválasztani a betöltött pozíciót egy legördülő listából. A regisztráció a
              pozíció kiválasztása, és a jogi nyilatkozat elfogadása után válik véglegessé.
            </p>
            <p>
              <strong>4. </strong>
              A Honlapot az MGFÜ Magyar Gazdaságfejlesztési Ügynökség (székhelye:1074 Budapest, Rákóczi út 70-72,
              cégjegyzékszáma: 01-09-980439, adószáma: 23833904-2-42, a továbbiakban: MGFÜ) üzemelteti.
            </p>
            <p>
              <strong>5. </strong>
              A tárhelyszolgáltató: ABPlusz Bt.
            </p>
            <p>
              Székhelye: 2049 Diósd, IV. Béla király utca 48.
            </p>
            <p>
              <strong>6. </strong>
              Jelen felhasználási feltételek módosítási jogát az MGFÜ fenntartja, a módosításról a Honlap főoldalán
              tájékoztatást közlünk, valamint a jelen felhasználási Feltételek legutóbbi frissítésének időpontját a
              Felhasználási Feltételek tetején lévő felirat melletti dátum mutatja.
            </p>
            <p>
              <strong>7. </strong>
              Amennyiben a jelen Felhasználási Feltételek és a Honlapon máshol meghatározott egyedi rendelkezések között
              bármilyen ellentmondás lenne, úgy a jelen Felhasználási Feltételek az irányadók.
            </p>
            <br clear="all" />
            <p>
              <strong>8. </strong>
              <strong>Szellemi alkotásokhoz fűződő jogok</strong>
            </p>
            <p>
              <strong>A Honlap tartalma:</strong>
            </p>
            <p>
              <strong></strong>
            </p>
            <p>
              A Honlap teljes tartalma szerzői jogi védelem alatt áll, a szabad felhasználás vonatkozó jogszabályokban
              rögzített eseteken (pl. idézés) kívül a Honlapon található szerzői jogi védelem alatt álló tartalom
              felhasználása csak a jelen felhasználási feltételekben foglalt módon történhet. Ettől eltérő felhasználás
              kizárólag az MGFÜ előzetes írásbeli engedélyével lehetséges különösen, de nem kizárólagosan ideértve a
              haszonszerzés (ideértve a kereskedelmi célú haszonszerzést is) céljából történő felhasználást, a
              többszörözést, módosítást, származékos mű létrehozását, terjesztést és közzétételt.
            </p>
            <p>
              <strong>Védjegyek és logók:</strong>
            </p>
            <p>
              <strong></strong>
            </p>
            <p>
              A Honlapon feltüntetett valamennyi védjegy és logó oltalom alatt áll.
            </p>
            <p>
              A Felhasználó a védjegyek és logók használatára, felhasználására, megjelenítésére csak a jogosult
              kifejezett engedélye esetén jogosult.
            </p>
            <p>
              <strong>9. </strong>
              <strong>Felelősség korlátozása:</strong>
            </p>
            <p>
              <strong></strong>
            </p>
            <p>
              <strong>a) </strong>
              Felhasználó a Honlapot saját kockázatára és felelősségére használja. A Felhasználó tudomásul veszi és
              elfogadja, hogy az MGFÜ - a jogszabály alapján nem kizárható eseteken kívül - nem felelős a Honlapra
              feltöltött tartalommal, a Honlap használatával, vagy használhatatlanságával összefüggésben a Felhasználót
              közvetlenül, vagy közvetve ért esetleges kárért.
            </p>
            <p>
              <strong>b) </strong>
              Az MGFÜ a Honlap hibátlan működéséért, a szolgáltatások folyamatos elérhetőségéért nem vállal
              felelősséget. Az MGFÜ továbbá nem vállal felelősséget azért, ha Felhasználó rendszerében a Honlap tartalma
              illetve a szolgáltatások kompatibilitási, vagy egyéb okok miatt nem elérhetők.
            </p>
            <p>
              <strong>c) </strong>
              Az MGFÜ nem felelős a Honlap meghibásodásából, a Honlapon történő böngészéssel vagy letöltéssel
              kapcsolatosan – a Felhasználónál közvetlenül, közvetetten keletkező kárért.
            </p>
            <p>
              <strong>d) </strong>
              A Honlapon elérhető szolgáltatások nem tekinthetők tanácsadásnak, következésképpen a Honlapon elérhető
              tartalom alapján Felhasználó által hozott döntések következményekén közvetve, vagy közvetlenül felmerülő
              kárért MGFÜ nem felelős.
            </p>
            <p>
              <strong>e) </strong>
              Az MGFÜ nem szavatolja, hogy a Honlapon található tartalom pontos, hiánytalan vagy naprakész és nem vállal
              felelősséget az ebből eredően a Felhasználót közvetetten, vagy közvetlenül ért kárért.
            </p>
            <p>
              <strong>f) </strong>
              A Honlapon esetlegesen feltüntetett más forrásra (pl. források, webhelyek) történő hivatkozás kizárólag
              tájékoztatás nyújtása céljából van megjelenítve. Az MGFÜ, mint a Honlap üzemeltetője nem vállal
              felelősséget az hivatkozások helyén található információk hitelességéért, egyszersmind az MGFÜ nem
              rendelkezik ellenőrzési joggal ezen forrásokban megtalálható adatok vonatkozásában.
            </p>
            <p>
              <strong>g) </strong>
              <strong>
                Az MGFÜ a Honlapon történő regisztrációval kapcsolatban kizárja felelősségét az alábbi károk kapcsán:
              </strong>
            </p>
            <p>
              • A Felhasználó által a regisztrációja során megadott valótlan adatok következtében a regisztrált
              társaságnak, vagy harmadik személynek okozott károkért bekövetkező esetleges károkért;
            </p>
            <p>
              • A Felhasználó regisztrációjára vonatkozó jogosultságának hiányából eredő, a regisztrált társaságnak,
              vagy harmadik személynek okozott károkért;
            </p>
            <p>
              • A Felhasználó Honlap használata során, regisztrált társaságként tett valamely nyilatkozatából eredő a
              regisztrált társaságnak, vagy harmadik személynek okozott károkért, ideértve azt az esetet is, amikor
              nyilatkozattételre nem jogosult Felhasználó tesz nyilatkozatot;
            </p>
            <p>
              • A Honlap szolgáltatásának igénybevételével a regisztrált társaságnak, vagy harmadik félnek okozott
              bármely károkért.
            </p>
            <p>
              <strong>10. </strong>
              <strong>Adatvédelem: </strong>
              A Honlap használatával kapcsolatban adatkezelési rendelkezéseket az Adatkezelési Tájékoztató tartalmazza,
              mely a jelen Felhasználási Feltételeknek elválaszthatatlan mellékletét képezi.
            </p>
            <p>
              <strong>11. </strong>
              Jelen felhasználási feltételeket megszegő felhasználó regisztrációja írásbeli figyelmeztetést követően –
              súlyosabb esetben haladéktalanul – törlésre, vagy ideiglenes felfüggesztésre kerülhet. MGFÜ a jelen
              Felhasználási feltételek megszegése következtében felmerülő károkat peres úton is érvényesítheti.
            </p>
            <p>
              <strong>12. </strong>
              <strong>
                A jelen Felhasználási Feltételekre a magyar jogszabályok az irányadók.
              </strong>
              <br />
              <br />
              Mindkét fél megállapodik abban, hogy Magyarország bíróságainak kizárólagos joghatósága van. A jelen
              Felhasználási Feltételek értelmezésére, a Felhasználási Feltételekből eredő vagy azzal összefüggő bármely
              vita vagy igény esetén a magyar bíróságok rendelkeznek kizárólagos joghatósággal.
            </p>
            <p>
              <strong>13. </strong>
              <strong>Kapcsolattartás</strong>
            </p>
            <p>
              Ha a Felhasználási Feltételekkel vagy a Honlappal kapcsolatban bármilyen kérdése vagy észrevétele van,
              kérjük, hogy a <a href="mailto:info@mgfu.hu">info@mgfu.hu</a> email címen vegye fel velünk a kapcsolatot.
            </p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse'
}
</script>
